export class Names {
  static asp = "Asparagus";
  static ctrlARM = "CtrlARM";
  static payClix = "PayClix";
  static cm = "Circuit Mouse";
  static miko = "Miko 3 Parent";
  static souqcards = "SouqCards";
  static bidForest = "BidForest";
  static mnm = "MNM Financial App";
  static hp = "Handprint for Partners";
  static nda = "National Demolition Association";
}

export class Description {
  static hp =
    "Use Grove Planter App to manage GMT projects on-the-go; caption reports & confirm fund deliveries for sustainable development.";
  static payClix =
    "Payclix mobile app simplifies & enhances online payment experience for existing and new customers via an exclusive, redefined payment interface.";
  static bidForest =
    "BidForest's reverse auction ensures the best price and seller for your product. Negotiate with sellers from home for a seamless online shopping experience.";
  static cm =
    "Make your Android device part of the Internet of Things (IoT) using the powerful CircuitMouse App - the flagship of the CircuitMouse Platform, which brings billions of devices to the IoT!";
  static mnm =
    "MNM Financial Service simplifies personal finance management. Easily record business and personal transactions, review daily, weekly, and monthly financial data, and generate spending reports.";
  static nda =
    "NDA Safety App enables registered members to access safety talks, record attendees, email completed trainings & access the complete Safety Manual for on-the-job reference and employee trainings.";
  static souqcards =
    "SouqCards app offers electronic cards for sale (PlayStation, Amazon, Xbox, etc.) with great deals and fast delivery. Our smart technology is designed to give you the power to shop anytime, anywhere.";
  static ctrlARM =
    "With CtrlARM, you can effortlessly safeguard your confidential information using a comprehensive encryption application that enables you to decrypt files with just one click. Keep your data secure with ease!";
  static asp =
    "Reduce stress from healthy living with our fresh, ready-prepared meals that cater to even the busiest lifestyles. We take care of the shopping, preparation, cooking, and delivery, so you can experience the benefits of clean eating without the hassle.";
  static miko =
    "Miko 3 Parent app connects you to the Miko 3 robot, providing access to its smart and fun features. Miko 3 is powered by deep learning AI, allowing it to connect with kids, understand their developmental phases, and accelerate learning, leading to increased intelligence.";
}

export class Review {
  static hp = "Very professional, intelligent developer.";
  static nda = "Completed the project, everything was fine.";
  static bf = "Excellent freelancer, pleasure to work with.";
  static souqcards =
    "Flawless as usual, pleasure to work with Jitendra as always.";
  static mnm =
    "A very professional developer. Adhered to the schedules and completed a quality work. Would love to work with again in future.";
  static cm =
    "Jitendra helped us with yet another app. He was terrific, as always, and we already have the next project with Jitendra lined up.";
  static armmar =
    "As usual, Jitendra is a delight to work with. We've worked with him on several projects and he has always delivered with the best outcome. We are happily working together continually.";
  static payclix =
    "Jitendra was experienced, knowledgeable and a great help in making our first project using Flutter a success.\nHe will definitely be our our first choice when we do our next Flutter project.";
  static miko =
    "Worked on multiple modules, some of them completely new. Jitendra took great responsibility of the tasks and delivered well on both UI and functionality. He was approachable and adjusted really well with our tough timelines";
}

export class ProjectLinks {
  static cm =
    "https://www.upwork.com/freelancers/~014885032ede7cc4c6?p=1493449456078921728";
  static mnm =
    "https://www.upwork.com/freelancers/~014885032ede7cc4c6?p=1343939823944085504";
  static miko =
    "https://www.upwork.com/freelancers/~014885032ede7cc4c6?p=1493453696830644224";
  static souqcards =
    "https://www.upwork.com/freelancers/~014885032ede7cc4c6?p=1493499820684865536";
  static nda =
    "https://www.upwork.com/freelancers/~014885032ede7cc4c6?p=1629404650513866752";
}

/// git init
/// git add .
/// git commit -m ""
/// git remote add origin https://github.com/jitendrapurohit12/jitendrapurohit12.github.io.git
/// git push -u -f origin main
/// git merge --allow-unrelated-histories
